
export default {
  name: 'CreateSections',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    mColor: {
      type: String,
      default: '#2362FB'
    },
    dropdownItems: Array
  },
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {},

  methods: {
    handleTypeClick: function handleTypeClick(type) {
      this.$emit('command-select', type);
    }
  }
};